<template>
  
  <div class="spacebattle">
    
    <div class="info" @click="openInfo" ></div>

    <div class="infoPopup">
      <ul>
        <li>
          <div class="bombed"></div>
          <span>Bombed</span>
        </li>

        <li>
          <div class="dead"></div>
          <span>Killed</span>
        </li>

        <li>
          <div class="distance"></div>
          <span>Minimal distance between <br>
          ships – one field</span>
        </li>
      </ul>
    </div>

    <div class="overlay"></div>

    <div class="battlefield">

      <ul class="numbers">
        <li>1</li>
        <li>2</li>
        <li>3</li>
        <li>4</li>
        <li>5</li>
      </ul>

      <ul class="letters">
        <li>A</li>
        <li>B</li>
        <li>C</li>
        <li>D</li>
        <li>E</li>
      </ul>
        
      
      <div class="spaceGrid" @click="chooseTarget">

        <div class="point" id="A1"></div>
        <div class="point" id="A2"></div>
        <div class="point" id="A3"></div>
        <div class="point" id="A4"></div>
        <div class="point" id="A5"></div>


        <div class="point" id="B1"></div>
        <div class="point" id="B2"></div>
        <div class="point" id="B3"></div> 
        <div class="point" id="B4"></div> 
        <div class="point" id="B5"></div> 

        <div class="point" id="C1"></div>
        <div class="point" id="C2"></div>
        <div class="point" id="C3"></div> 
        <div class="point" id="C4"></div> 
        <div class="point" id="C5"></div> 

        <div class="point" id="D1"></div>
        <div class="point" id="D2"></div>
        <div class="point" id="D3"></div> 
        <div class="point" id="D4"></div> 
        <div class="point" id="D5"></div> 

        <div class="point" id="E1"></div>
        <div class="point" id="E2"></div>
        <div class="point" id="E3"></div> 
        <div class="point" id="E4"></div> 
        <div class="point" id="E5"></div> 

      </div>

    </div>
    
    <div class="shooter">
      <p>{{player}} {{shots}} shots</p>
      <div class="aim">
        <span> {{targetId}} </span>
        <div class="top"></div>
        <div class="bottom"></div>
        <div class="right"></div>
        <div class="left"></div>
      </div>

      <button :class="buttonClass" @click="shoot"> {{ msg }} </button>
    </div>
  </div>    

</template>

<script>

  require ('../css/spacebattle.css')

  export default {

  name: 'spaceBattle',

  // props: [ "videoMov" ],

  data (){
    return {
      battlefield: {},
      grids: {},
      buttonbomb: {},
      ships: [],
      msg: 'Choose Target',
      buttonClass: 'inactive',
      player: 'You have',
      finalLost: false,

      infoOpen: false,

      targetId: '',
      
      shots: 3,
      userWin: false,
      userLost: false
    }
  },

  methods: {

    setShips(){
      // defining objects
      this.battlefield = document.getElementsByClassName('spaceGrid')[0]  
      this.grids = this.battlefield.getElementsByClassName('point');
      this.buttonbomb = document.querySelector('.shooter button')


      // ships sets   
      this.ships[0] = [
        ['C3'],
        ['E3'],
        ['A4', 'A5'],
        ['C1', 'D1'],
        ['C5', 'D5', 'E5']
      ]

      this.ships[1] = [
        ['A5'],
        ['C5'],
        ['A1', 'A2'],
        ['E3', 'E4'],
        ['C1', 'C2', 'C3']
      ]

      this.ships[2] = [
        ['A1'],
        ['C1'],
        ['B3'],
        ['D5'],
        ['A5', 'B5'],
        ['D3', 'E3',]
      ]

      // randomize ships
      this.ships = this.ships[Math.floor(Math.random() * 3)]

      // Set ships to battlefield
      for (var j = 0; j < this.ships.length; j++) {
        let ship = this.ships[j];

        for (var i = 0; i < ship.length; i++) {

          document.getElementById(ship[i]).classList.add('ship');

        }
      }

    },
    chooseTarget(event){

      let target

      for (var i = 0; i < this.grids.length; i++) {
        target = this.grids[i];

        if (target.classList.contains('selected')) {
          target.classList.remove('selected');
        }
      }

      target = event.path[0]

      if ( !target.classList.contains('bombed') && !target.classList.contains('missed')) {
        target.classList.add('selected');

        this.targetId = target.id
        this.msg = 'Shoot!'
        this.buttonClass = 'enabled'

      }

    },

    shoot(){

      for (var i = 0; i < this.grids.length; i++) {
        let target = this.grids[i];

        if (target.classList.contains('selected')) {

          target.classList.remove('selected');

          if (target.classList.contains('ship')) {
            target.classList.add('bombed');
            this.msg = 'Choose Target';
            this.buttonClass = 'inactive'
          } else {
            target.classList.add('missed');
            --this.shots
          }
        }
      }      

      if (this.shots === 0 && !this.userLost) {
        console.log('You have no more shots!');

        // if didn't drop ogre out of spac ship has 3 more shots
        if( !this.$store.state.hidden.some(e => e === 'ogre-drop') && !this.finalLost) {
            this.shots = 3
            this.msg = 'Choose Target';
            this.buttonClass = 'inactive'
            this.player = 'Ogre has'
            this.finalLost = true
            return

        } else 
          document.querySelector('.shooter p').innerHTML = 'You lost!'
          this.msg = 'Okay..';
          this.buttonClass = 'enabled'
          this.userLost = true;
          
          return;
      }

 

      // Convert bombed to dead
      for (var j = 0; j < this.ships.length; j++) {
        var ship = this.ships[j];

        var isDead = true;
        for (var i = 0; i < ship.length; i++) {
          if (!document.getElementById(ship[i]).classList.contains('bombed')) {
            isDead = false;
          }
        }

        if (isDead) {
          for (var i = 0; i < ship.length; i++) {
            document.getElementById(ship[i]).classList.add('dead');
          }
        }
      }

      // Is Win?
      this.userWin = true;

      for (var j = 0; j < this.ships.length; j++) {
        var ship = this.ships[j];

        var isDead = true;
        for (var i = 0; i < ship.length; i++) {
          if (!document.getElementById(ship[i]).classList.contains('bombed')) {
            isDead = false;
          }
        }

        if (!isDead) {
          this.userWin = false
        }
      }

      if (this.userWin) {
        document.querySelector('.shooter p').innerHTML = 'You Won!'
        this.buttonClass = 'enabled'
        this.msg = 'OH YEA!!'
        this.userWin = true
      }

      // emiting loadNext
      if (this.userLost){
        this.$emit('gameOver', 'spacebattle-death')
      }

      if (this.userWin){
        this.$emit('gameOver', 'spacebattle-win')
      }

    },

    openInfo(){
      if(!this.infoOpen){
        document.querySelector('.spacebattle').classList.add('infoOpen')
        this.infoOpen = true
        return
      } else {
        document.querySelector('.spacebattle').classList.remove('infoOpen')
        this.infoOpen = false
        return
      }
      
    }
  },

  mounted: function (){
    this.setShips()

      this.$ga.event({
        eventCategory: 'Spacebattle',
        eventAction: 'Spacebattle',
        eventValue: this.$store.state.player.adChance
      }) 
  }
}
</script>